export const formatString = (inputString) => {
    const parts = inputString.split(',');

    return parts.map((part, index) => {
        const segments = part.trim().split('x');
        const itemName = segments[1];
        const itemQuantity = segments[2];
        return (
            <span key={index} className="flex flex-col items-start">
                {itemName} x{itemQuantity}
                <br />
            </span>
        );
    });
};

export const getStudentName = (clientLogin) => {
    const safeLogin = clientLogin || ""; 
    const regex = /\/\s*(.+)$/;
    const match = safeLogin.match(regex);
    return match ? match[1] : "";
};

export const getLogin = (clientLogin) => {
    const safeLogin = clientLogin || "";
    const parts = safeLogin.split('/');
    return parts[0] ? parts[0].trim() : "";
};

export const createItemListFromString = (input, priceMap) => {
    const items = input.split(',').map(item => item.trim());
    const result = [];

    items.forEach(str => {
        const regex = /^(\d+)\s+x(.+?)\s+x(\d+)\s+x(\w+)\s+x([\d.]+)$/;
        const match = str.match(regex);

        if (match) {
            const [, id, name, quantity, type, price] = match;

            result.push({
                id: parseInt(id),
                name: name.trim(),
                quantity: parseInt(quantity),
                price: parseFloat(price),
                type: type.trim(),
            });
        } else {
            console.warn(`Formato não reconhecido: ${str}`);
        }
    });

    return result;
};

export const extractOrderItems = (itemsList) => {
    if (!itemsList) return [];

    return itemsList.split(',').map(item => {
        const parts = item.trim().split(' x');
        const name = parts[1]?.trim() || '';
        const quantity = parseInt(parts[2]) || 0;
        const type = parts[3]?.trim() || '';

        return { name, quantity, type };
    });
}

export const extractQuantityFromName = (name) => {
    const match = name.match(/x(\d+)$/);
    return match ? parseInt(match[1], 10) : 1;
};


export const normalizePaymentMethod = (method) => {
    if (!method) return "Outro";

    const normalized = method.trim().toLowerCase();

    if (normalized.includes("pix")) return "PIX";
    if (normalized.includes("dinheiro")) return "Dinheiro";
    if (normalized.includes("va") || normalized.includes("vr")) return "VA | VR";
    if (normalized.includes("credito foodz")) return "Crédito Foodz";

    if (normalized.includes("credito") && normalized.includes("visa")) return "Crédito/Visa";
    if (normalized.includes("credito") && normalized.includes("mastercard")) return "Crédito/Mastercard";
    if (normalized.includes("credito") && normalized.includes("elo")) return "Crédito/Elo";
    if (normalized.includes("credito") && normalized.includes("amex")) return "Crédito/Amex";
    if (normalized.includes("credito") || normalized.includes("credit_card") || normalized.includes("credit card")) return "Crédito/Outro";

    if (normalized.includes("debito") && normalized.includes("visa")) return "Débito/Visa";
    if (normalized.includes("debito") && normalized.includes("mastercard")) return "Débito/Mastercard";
    if (normalized.includes("debito") && normalized.includes("elo")) return "Débito/Elo";
    if (normalized.includes("debito") && normalized.includes("amex")) return "Débito/Amex";
    if (normalized.includes("debito") || normalized.includes("debit_card") || normalized.includes("debit card")) return "Débito/Outro";

    return "Outro";
};

export const stripPrefix = (tipo) => {
    return tipo
        .replace(/^Pedido Online - /, '')
        .replace(/^Recarga Online - /, '')
        .replace(/^Pedido Crédito Foodz - /, '')
        .replace(/^Pedido - /, '')
        .replace(/^Recarga - /, '');
};

export const toTitleCase = (str) => {
    return str
        .toLowerCase()
        .trim()
        .split(/\s+/)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
};
